export default "__VITE_ASSET__BQ_Mtt9u__"